<script>import {
  cfgBrandTitle,
  cfgToThemeCdnPath,
  cfgToThemeContentPath,
  FeatureSet,
  stateFeatureSet,
  stateUi
} from "@infinitro/config";
import { Container } from "@infinitro/container";
import { t, Verbiage } from "@infinitro/content";
import { isFullScreenGame, locale, loggedIn, stateShowSeal, toSiteUrl } from "@infinitro/global";
import MarkdownIt from "markdown-it";
import AccordionSection from "./parts/accordion-section.svelte";
import Link from "./parts/link.svelte";
import Seal from "./parts/seal.svelte";
import SocialMedia from "./parts/social-media.svelte";
const BRAND_NAME = cfgBrandTitle();
const md = new MarkdownIt({
  html: true,
  breaks: true,
  linkify: true
});
let htmlContent = "";
let content = "";
async function fetchContent(isFallback = false) {
  try {
    const response = await fetch(content);
    if (!response.ok) throw new Error(`Error fetching content: ${response.statusText}`);
    let text = await response.text();
    text = text.replace(/%(domain|brand)%/g, BRAND_NAME);
    htmlContent = md.render(text);
  } catch (error) {
    console.error("Failed to fetch footer legals:", error);
    if (!isFallback) {
      content = cfgToThemeContentPath(`/legals/legals.en.md`);
      await fetchContent(true);
    } else {
      htmlContent = "";
    }
  }
}
$: {
  if ($stateUi.footer?.useLegalsMarkdownContent) {
    content = cfgToThemeContentPath(`/legals/legals.[locale].md`).replace("[locale]", $locale);
    fetchContent();
  } else {
    htmlContent = "";
  }
}
</script>

{#if !$isFullScreenGame}
	<nav class="footer" id="footerId">
		<div class="accordion-section-container">
			<AccordionSection />
		</div>
		<Container>
			<div class="footer-text-container">
				<div class="footer-markdown">{@html htmlContent}</div>
			</div>

			<div class="social-media-container">
				<SocialMedia />
			</div>

			<div class="copyright">
				<p class="footer-text">
					&copy;{new Date().getFullYear()}
					{cfgBrandTitle()}
					{$t(Verbiage.all_rights_reserved)}
				</p>
			</div>

			<div class="logo-container">
				<a href={toSiteUrl('/', $loggedIn)} class="logo">
					<img src={cfgToThemeCdnPath(`/misc/logo.svg`)} alt={$t(Verbiage.logo_alt, 'alts')} />
				</a>
			</div>

			<div class="seal-container">
				{#if $stateShowSeal}
					<Seal />
				{/if}
			</div>
		</Container>
	</nav>
{/if}

<style>
	.footer {
		z-index: 40;
		width: 100%;
		padding-left: 12px;
		padding-right: 12px;
		padding-bottom: 70px;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity));
		font-family: var(--font-main);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border-style: none;
		background: radial-gradient(
			100% 250% at 50% -150%,
			rgba(var(--color-primary-500-rgb) / 0.8) 0%,
			var(--color-background-900) 100%
		)
}

	.footer-text-container {
		width: 100%;
		max-width: 1168px;
		text-align: start;
		color: var(--color-text-300)
}

	@media (min-width: 1024px) {
		.footer {
				padding-left: 22px;
				padding-right: 22px;
				padding-bottom: 40px
		}
		.footer-text-container {
				padding-left: 10rem;
				padding-right: 10rem;
				padding-top: 3rem;
				padding-bottom: 3rem;
				text-align: center
		}
	}

	.footer-markdown {
		width: 100%
}

	:global(.footer-markdown p),
	:global(.footer-markdown ul),
	:global(.footer-markdown ol) {
		margin-bottom: 0.5rem;
		font-size: 12px;
		font-family: var(--font-main)
}

	:global(.footer-markdown a) {
		text-decoration-line: underline
}

	:global(.footer-markdown br) {
		display: block;
		height: 0.5rem;
		--tw-content: '';
		content: var(--tw-content)
}

	.accordion-section-container {
		display: flex;
		width: 100%;
		flex-direction: column;
		max-width: 1232px
}

	.copyright {
		margin-bottom: 0.5rem;
		margin-top: 1rem;
		text-align: center;
		color: var(--color-text-300)
}

	.copyright .footer-text {
		font-size: 12px
}
</style>
